import { BackendInfo } from "models/backend-info";
import { handleError } from "./clift-api-errors";
import { parseResponse } from "./response-parser";

export const fetchBackendInfo = (): Promise<BackendInfo> =>
  fetch(`/api/backend-info`, {
    method: "GET",
  })
    .then(parseResponse)
    .catch((e) => handleError(e));
